import React from "react";
import { Link } from "react-router-dom";
import JointPhotosIconFixedColors from "../joint-photos-icon-fixed-colors.svg";

type LegalLayoutProps = {
  title: string;
  updatedAt: string;
  children: React.ReactNode;
};

export default function LegalLayout({ title, updatedAt, children }: LegalLayoutProps) {
  React.useEffect(() => {
    document.title = `${title} • joint.photos`;
  }, [title]);

  return (
    <div data-section="legal-layout-root" className="min-h-screen flex items-start justify-center px-4 py-10">
      <div className="w-full max-w-3xl">
        <div className="mb-6 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 no-underline">
            <img src={JointPhotosIconFixedColors} alt="joint.photos" width={34} height={34} draggable={false} />
            <div className="text-white">
              <div className="text-lg font-semibold leading-tight">
                <span className="text-emerald-400">joint.</span>
                <span className="text-sky-400">photos</span>
              </div>
              <div className="text-xs text-slate-200/80 leading-tight">Back to app</div>
            </div>
          </Link>

          <div className="text-right">
            <div className="text-xs text-slate-200/80">Last updated</div>
            <div className="text-sm text-slate-100">{updatedAt}</div>
          </div>
        </div>

        <div className="rounded-2xl border border-white/15 bg-white/10 backdrop-blur-xl shadow-2xl p-6 sm:p-10 text-slate-100">
          <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
          <div className="mt-6 space-y-6 text-sm sm:text-base leading-7">{children}</div>
        </div>
      </div>
    </div>
  );
}

